import React, { useContext, FC } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import CharacterCount from '../items/CharacterCount';
import Reaction from '../buttons/Reaction';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';

import s from './PollMenu.scss';

export interface Props {
  noAtomics?: boolean;
}

const PollMenu: FC<Props> = ({ noAtomics = false }) => {
  const editor = useEditorContext();
  const forceUpdate = useForceUpdate();
  const isMobile = useContext(MobileContext);

  // Listen to editor as its not react so we need to react here
  editor?.on('transaction', () => {
    forceUpdate();
  });

  if (!editor) {
    return null;
  }

  return (
    <ThemeOverride
      themeSurface={ThemeSurface.TERTIARY}
      className={cn(s['root'])}
    >
      <CharacterCount editor={editor} />
      {!noAtomics && !isMobile && <Reaction editor={editor} />}
    </ThemeOverride>
  );
};
PollMenu.displayName = 'PollMenu';

export default PollMenu;
